import React from 'react';
import { PlayIcon } from 'lucide-react';
import { helpVideoUrl, images } from '../data/content';
export function HelpVideo() {
  return <section aria-labelledby="video-title" className="bg-cream" data-id="element-60" data-mp="t0idqe77hae7">
      
    </section>;
}